import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { gitflicPipelinesApiExtension } from './api';
import { entityGitflicPipelinesCard } from './entityCards';

export default createFrontendPlugin({
  pluginId: 'gitflic-pipelines',
  extensions: [gitflicPipelinesApiExtension, entityGitflicPipelinesCard],
});
